import React from "react";
import { useIntl } from "react-intl";
import { Box, Paper, Typography } from "@mui/material";
import { IUserDto } from "../../generated/api-client";
import { formatDate } from "../../utils/date.utils";
import { useI18n } from "../../i18n-context";

interface UserFieldsCardProps {
  user: IUserDto;
}

export function UserFieldsCard({ user }: UserFieldsCardProps) {
  const intl = useIntl();
  const { locale } = useI18n();

  const fields = [
    { key: "id", label: intl.formatMessage({ id: "id" }), value: user.id },
    {
      key: "name",
      label: intl.formatMessage({ id: "name" }),
      value: user.name,
    },
    {
      key: "lastName",
      label: intl.formatMessage({ id: "lastName" }),
      value: user.lastName,
    },
    {
      key: "email",
      label: intl.formatMessage({ id: "email" }),
      value: user.email,
    },
    {
      key: "isActive",
      label: intl.formatMessage({ id: "isActive" }),
      value: user.isActive
        ? intl.formatMessage({ id: "yes" })
        : intl.formatMessage({ id: "no" }),
    },
    {
      key: "phoneNumber",
      label: intl.formatMessage({ id: "phoneNumber" }),
      value: user.phoneNumber,
    },
    {
      key: "postalCode",
      label: intl.formatMessage({ id: "postalCode" }),
      value: user.postalCode,
    },
    {
      key: "country",
      label: intl.formatMessage({ id: "country" }),
      value: user.country,
    },
    {
      key: "city",
      label: intl.formatMessage({ id: "city" }),
      value: user.city,
    },
    {
      key: "address",
      label: intl.formatMessage({ id: "address" }),
      value: user.address,
    },
    {
      key: "isTester",
      label: intl.formatMessage({ id: "isTester" }),
      value: (user as any).isTester
        ? intl.formatMessage({ id: "yes" })
        : intl.formatMessage({ id: "no" }),
    },
    {
      key: "updateDate",
      label: intl.formatMessage({ id: "updateDate" }),
      value: formatDate(user.updateDate, locale),
    },
  ];

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, pb: 2 }}>
      {fields.map((field) => (
        <Box
          key={field.key}
          sx={{ flex: "1 1 calc(50% - 8px)", minWidth: "250px" }}
        >
          <Paper elevation={1} sx={{ p: 2 }}>
            <Typography variant="overline" display="block">
              {field.label}
            </Typography>
            <Typography variant="body1">{field.value || "-"}</Typography>
          </Paper>
        </Box>
      ))}
    </Box>
  );
}
